import { Component } from 'react';

// Helper function to generate unique IDs
const generateId = () => {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  );
};

class KeyRatiosDesktop extends Component<any> {
  private getInsightPara(insight: any) {
    let para;
    const fundValue = parseFloat(insight.fund);
    const categoryValue = parseFloat(insight.catgory);
    switch (insight.type) {
      case 'ALPHA':
      case 'SHARPE':
        para =
          fundValue > categoryValue ? (
            <span style={{ color: '#30A882' }} className="lil-text-base">
              Better than category avg
            </span>
          ) : (
            <span style={{ color: '#D0483D' }} className="lil-text-base">
              Below category avg
            </span>
          );
        break;
      case 'BETA':
      case 'CAPTURE':
        para =
          fundValue < categoryValue ? (
            <span style={{ color: '#30A882' }} className="lil-text-base">
              Better than category avg
            </span>
          ) : (
            <span style={{ color: '#D0483D' }} className="lil-text-base">
              Below category avg
            </span>
          );
        break;
      default:
        break;
    }
    return para;
  }

  public render() {
    const { insights } = this.props;

    // Define table headers
    const tableHeaders = [
      {
        title: 'Ratio',
        textClass: 'lil-text-s-14 lil-font-semibold',
      },
      {
        title: 'This Fund',
        textClass: 'lil-text-s-14 lil-font-semibold',
      },
      {
        title: 'Category Avg',
        textClass: 'lil-text-s-14 lil-font-semibold',
      },
      {
        title: 'Insight',
        textClass: 'lil-text-s-14 lil-font-semibold',
      },
    ];

    return (
      <div
        itemScope
        itemType="http://schema.org/Table"
        className="sm:lil-pb-6 sm:lil--mx-6 sm:lil-w-auto lil-pb-10"
      >
        <h2 itemProp="about" className="lil-hidden">
          Key risk & return ratios
        </h2>
        <p className="lil-text-s-18 lil-pt-2 lil-pb-4 sm:lil-ml-6 sm:lil-text-base">
          Compared to other funds in the category
        </p>
        <div className="lil-overflow-x-auto lil-scrolling-touch">
          <table
            className="lil-border-separate lil-w-auto lil-shadow-sm lil-border-sm lil-rounded-xl lil-border-spacing-0 lil-border-grey-300 lil-mt-4 sm:lil-mx-6"
            style={{
              minWidth: '600px',
              tableLayout: 'auto',
            }}
          >
            <thead>
              <tr style={{ backgroundColor: '#D9F2F4' }}>
                {tableHeaders.map((header, index) => (
                  <th
                    className={`lil-text-left lil-py-4 lil-pl-4 sm:lil-pl-2 lil-border-b-sm lil-border-r-sm lil-border-grey-300 ${
                      index === 0 ? 'lil-rounded-tl-xl' : ''
                    } ${
                      index === tableHeaders.length - 1
                        ? 'lil-rounded-tr-xl'
                        : ''
                    }`}
                    style={{
                      borderRight:
                        index === tableHeaders.length - 1 ? 'none' : undefined,
                    }}
                    key={generateId()}
                  >
                    <p
                      className={`lil-text-center ${header.textClass}`}
                      style={{ color: '#437276' }}
                    >
                      {header.title}
                    </p>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {insights.map((insight: any, rowIndex: number) => (
                <tr key={generateId()}>
                  {['title', 'fund', 'catgory', 'insight'].map(
                    (field, colIndex) => (
                      <td
                        key={generateId()}
                        className={`lil-py-2 lil-pl-4 lil-font-medium lil-w-1/4 ${
                          field === 'title'
                            ? 'lil-text-left lil-pr-2'
                            : 'lil-text-center'
                        } lil-border-b-sm lil-border-r-sm lil-border-grey-300`}
                        style={{
                          borderRight: colIndex === 3 ? 'none' : undefined,
                          borderBottom:
                            rowIndex === insights.length - 1
                              ? 'none'
                              : undefined,
                        }}
                      >
                        {field === 'title' ? (
                          <span className="lil-text-base">{insight.title}</span>
                        ) : field === 'fund' ? (
                          <span className="lil-text-base">{insight.fund}%</span>
                        ) : field === 'catgory' ? (
                          <span className="lil-text-base">
                            {insight.catgory}%
                          </span>
                        ) : (
                          this.getInsightPara(insight)
                        )}
                      </td>
                    )
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default KeyRatiosDesktop;



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/keyRatios/keyRatiosDesktop.tsx